var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditcctvdetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8889 1H2.11111C1.49746 1 1 1.49746 1 2.11111V4.33333C1 4.94698 1.49746 5.44444 2.11111 5.44444H19.8889C20.5025 5.44444 21 4.94698 21 4.33333V2.11111C21 1.49746 20.5025 1 19.8889 1Z",
    stroke: "#ECECEC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 17.6667C13.4547 17.6667 15.4446 15.6769 15.4446 13.2223C15.4446 10.7677 13.4547 8.77783 11.0001 8.77783C8.54551 8.77783 6.55566 10.7677 6.55566 13.2223C6.55566 15.6769 8.54551 17.6667 11.0001 17.6667Z",
    stroke: "#ECECEC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 13.2221H11.0111M18.7777 5.44434V13.2221C18.7777 15.2849 17.9583 17.2632 16.4997 18.7218C15.041 20.1804 13.0627 20.9999 10.9999 20.9999C8.93715 20.9999 6.95884 20.1804 5.50023 18.7218C4.04161 17.2632 3.22217 15.2849 3.22217 13.2221V5.44434H18.7777Z",
    stroke: "#ECECEC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditcctvdetails);
export default __webpack_public_path__ + "static/media/editcctvdetails.0c90f0e08611681d959760893e90fcce.svg";
export { ForwardRef as ReactComponent };